import React from 'react';

import MuiButton from '@material-ui/core/Button';
import MuiIconButton from '@material-ui/core/IconButton';
import MuiTooltip from '@material-ui/core/Tooltip';

export default React.forwardRef(function Button(props, ref)
{
  const {
    label,
    icon,
    noLabel,
    ...rest
  } = props;

  if (noLabel) {
    return (
      <MuiTooltip title={label} enterDelay={300}>
        <MuiIconButton {...rest} ref={ref}>
          {icon}
        </MuiIconButton>
      </MuiTooltip>
    );
  }
  else {
    return (
      <MuiButton {...rest} startIcon={icon} ref={ref}>
        {label}
      </MuiButton>
    );
  }
});